import React, { useState } from 'react';
import { NavigateBeforeRounded, NavigateNextRounded } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

export type TokenPaginationProps = {
    rowsPerPage: number;
    setRowsPerPage: (size: number) => void;
    onNext: () => void;
    onPrev: () => void;
    canGoPrev: boolean;
    canGoNext: boolean;
    onRowsPerPageChange?: () => void;
    dynamicTextColors?: any;
}

const TokenPagination: React.FC<TokenPaginationProps> = ({
    rowsPerPage,
    setRowsPerPage,
    onNext,
    onPrev,
    canGoPrev,
    canGoNext,
    onRowsPerPageChange,
    dynamicTextColors,
}) => {
    const { t } = useTranslation();
    const curList = [10, 20, 50, 100];
    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => setIsOpen(!isOpen);

    const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
    const buttonTextColorClass = dynamicTextColors?.buttonTextColorClass || '';

    const handleRowsPerPageSelect = (size: number) => {
        setRowsPerPage(size);
        setIsOpen(false);
        onRowsPerPageChange?.();
    };

    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center">
                <div
                    className={`text-sm ${pageTextColorClass} ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                    style={{ color: pageTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                >
                    {t("common.rowsPerPage")}
                </div>
                <div className="relative h-[30px]">
                    <button
                        onClick={toggleDropdown}
                        className={`flex items-center h-full justify-between px-3 py-2 text-sm font-medium whitespace-nowrap rounded-lg ${inputBoxTextColorClass} ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        style={{ color: inputBoxTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                    >
                        <span>{rowsPerPage}</span>
                    </button>

                    {isOpen && (
                        <ul className="absolute z-10 bottom-full mb-1 bg-inputbox-color border border-slate-800 rounded-lg shadow-lg w-full">
                            {curList.map((size) => (
                                <li
                                    key={size}
                                    onClick={() => handleRowsPerPageSelect(size)}
                                    className={`px-3 py-2 text-xs hover:bg-zinc-700 cursor-pointer ${inputBoxTextColorClass} ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                    style={{ color: inputBoxTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                                >
                                    {size}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <div>
                {canGoPrev && (
                    <div
                        className={`pagination-btn ${buttonTextColorClass} ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        onClick={onPrev}
                        style={{ color: buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                    >
                        <NavigateBeforeRounded />
                    </div>
                )}
            </div>
            <div className="flex">
                {canGoNext && (
                    <div
                        className={`pagination-btn ${buttonTextColorClass} ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        onClick={onNext}
                        style={{ color: buttonTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}
                    >
                        <NavigateNextRounded />
                    </div>
                )}
            </div>
        </div>
    );
};

export default TokenPagination;
